export default "__VITE_ASSET__DAGpeh_$__"